import http from '@axios'
import paramsConverter from './utils/paramsConverter'

const resource = '/api/v1/setting-violation'

export default {
  list(params = {}) {
    const paramsString = paramsConverter(params)

    return http.get(`${resource}${paramsString}`)
  },
  get(uuid) {
    return http.get(`${resource}/${uuid}`)
  },
  update(violationSetting, uuid) {
    return http.post(`${resource}/${uuid}?_method=PUT`, violationSetting)
  },
  add(violationSetting) {
    return http.post(`${resource}`, violationSetting)
  },
  destroy(uuid) {
    return http.delete(`${resource}/${uuid}`)
  },
}
